var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangleBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273,
    height: 132,
    viewBox: "0 0 273 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58184",
    "data-name": "Group 58184",
    transform: "translate(-633 -323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58183",
    "data-name": "Group 58183",
    transform: "translate(0 5.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page_under_construction",
    transform: "translate(595.167 316.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M348.036,207.189H159.343c-1.754,0-3.18-1.805-3.18-4.025s1.427-4.025,3.18-4.025H348.036c1.754,0,3.18,1.805,3.18,4.025S349.79,207.189,348.036,207.189Z",
    transform: "translate(-105.33 -114.842)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M360.375,176.189H121.586a4.025,4.025,0,1,1,0-8.049H360.375a4.025,4.025,0,0,1,0,8.049Z",
    transform: "translate(-65.868 -104.635)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155384",
    "data-name": "Path 155384",
    d: "M119.084,176.189h90.358c.84,0,1.523-1.805,1.523-4.025s-.683-4.025-1.523-4.025H119.084c-.84,0-1.523,1.805-1.523,4.025S118.245,176.189,119.084,176.189Z",
    transform: "translate(86.705 -63.735)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M333.4,238.189H200.586a4.025,4.025,0,0,1,0-8.049H333.4a4.025,4.025,0,0,1,0,8.049Z",
    transform: "translate(-145.728 -125.048)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155385",
    "data-name": "Path 155385",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(148.079 -83.682)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155386",
    "data-name": "Path 155386",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(146.535 -143.682)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155387",
    "data-name": "Path 155387",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(104.535 -143.682)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155388",
    "data-name": "Path 155388",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(62.535 -143.682)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155389",
    "data-name": "Path 155389",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(20.535 -143.682)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155390",
    "data-name": "Path 155390",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(-21.465 -143.682)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155391",
    "data-name": "Path 155391",
    d: "M118.084,176.189H149.07c.288,0,.522-1.805.522-4.025s-.234-4.025-.522-4.025H118.084c-.288,0-.522,1.805-.522,4.025S117.8,176.189,118.084,176.189Z",
    transform: "translate(-63.465 -143.682)",
    fill: "#d0d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7160",
    "data-name": "Rectangle 7160",
    transform: "translate(633 323)",
    fill: "none",
    stroke: "#d0d0d0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 132,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 272,
    height: 131,
    rx: 19.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleBox);
export default __webpack_public_path__ + "static/media/rectangle_box.671a1997b5e32f099a6eb11cfa242af0.svg";
export { ForwardRef as ReactComponent };